
/* @flow */
import React, { PropTypes } from 'react';
import { UserService } from 'frilans-finans';
import Translate from 'react-translate-component';
import { proxyCounterpart } from '../../../scripts/proxyCounterpart';

import Utils from 'frilans-finans/utils/utils';
import ModalContainer from '../../../frilans-finans/modal/modal-container';
import SaveVacationOptions from './save-vacation-options';
import { SpinnerButton } from 'components/spinner-button/spinner-button';

export class InvoiceToolSelectVacationModal extends React.Component {

  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggleModal: PropTypes.func.isRequired,
    callback: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      userData: {
        saveVacationPay: props.user.saveVacationPay
          ? { value: props.user.saveVacationPay, valid: true }
          : { value: null, valid: false }
      },
      loading: false
    };

    this.callback = this.callback.bind(this);
    this.submit = this.submit.bind(this);
    this.handleSuccess = this.handleSuccess.bind(this);
    this.handleError = this.handleError.bind(this);
    this.resetState = this.resetState.bind(this);
  }

  resetState () {
    this.setState({
      userData: {
        saveVacationPay: this.props.user.saveVacationPay
          ? { value: this.props.user.saveVacationPay, valid: true }
          : { value: null, valid: false }
      }
    });
  }

  callback (name, values) {
    var tempFormValues = this.state.userData;
    tempFormValues[name] = values;
    this.setState({ userData: tempFormValues });
  }

  submit () {
    const userData = Utils.getPostParams(this.state.userData);

    const userUpdateData = {
      saveVacationPay: userData.saveVacationPay
    };

    this.setState({
      loading: true,
      postError: false
    });

    UserService.update(userUpdateData)
      .then(this.handleSuccess)
      .catch(this.handleError);
  }

  handleSuccess () {
    this.setState({
      loading: false
    });
    this.props.callback();
    this.props.toggleModal(false);
  }

  handleError (error) {
    let errors = UserService.getError(error);

    this.setState({
      loading: false,
      error: true,
      errorMessage: errors
    });
  }

  render () {
    if (this.props.isOpen) {
      return (
        <ModalContainer
          isOpen
          hideClose
          callback={this.props.toggleModal}
          title='MODAL_SAVE_VACATION_TITLE'
          classes='complete-information-modal'
        >
          <div className='modal-information-container'>
            <div className='input-row-container'>
              <Translate content='MODAL_SAVE_VACATION_BODY' className='invoicing-description' />
            </div>
            <div className='input-row-container top-divider'>
              <SaveVacationOptions
                callback={this.callback}
                userData={this.state.userData}
                reverseButtonOrder
                hideTitle
              />
            </div>
            <div className="new-modal-button-container no-margin top-divider">
              <SpinnerButton
                text={proxyCounterpart('SAVE')}
                loading={this.state.loading}
                classes='btn'
                callback={this.submit}
                disabled={!this.state.userData.saveVacationPay.valid}
              />
            </div>
          </div>
        </ModalContainer >
      );
    } else {
      return null;
    }
  }
}

export default InvoiceToolSelectVacationModal;



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/complete-information-modal/invoice-tool-select-vacation-modal.js
 **/